import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import pubSub from "utils/pub-sub";
import Modal from "shared/Modal";
import { importLangResources } from "locale";

importLangResources("version");

const VersionChangedModal = ({ isReady = true }) => {
  const { t } = useTranslation();
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    const fnVersionChanged = () => {
      setVisible(true);
    };
    pubSub.on("versionChanged", fnVersionChanged);
    return () => {
      pubSub.off("versionChanged", fnVersionChanged);
    };
  }, []);

  const onClose = () => {};

  const update = () => {
    window.location.reload();
  };

  if (!isVisible || !isReady) {
    return null;
  }

  return (
    <Modal isOpen={isVisible} onClose={onClose}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">
            <i>
              <FontAwesomeIcon icon="redo-alt" />
            </i>
            <span>{t("version:title")}</span>
          </h5>
        </div>
        <div className="modal-body">{t("version:content")}</div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={update}>
            {t("version:refresh")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default VersionChangedModal;
